import Vue from 'vue';
import Vuex from 'vuex';
//import json from './../../global.json';

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		globalData: {
			siteId: '16',
			name: "Gîte d'en Lébé",
			adresse: '',
			codePostal: '32430',
			ville: 'Touget',
			pays: 'France',
			telephone: '05 62 06 81 86',
			bandeauVertTel:"06 84 81 88 81",
			bandeauVertTel2:"06 63 35 90 42",
			telephonePortable: '06 84 81 88 81',
			telephoneCountryCode: '+33(0)5 62 06 81 86',
			fax: '',
			position: {
				latitude: '43.6675209',
				longitude: '0.9201465',
			},
			email: 'contact@gitedenlebe.fr',
			emailBandeauVert: 'enlebegite@gmail.com',
			mentionLegales: {
				formeJuridique: 'SARL',
				siret: '802 954 785',
				nic: '00028',
				APE: '54541U',
				immatriculation: 'n°immatriculation',
				directeurPublication: 'Mr Director DelaPublicacion',
			},
		},
		gbbuArticles: null,
		count: 0,
	},
	mutations: {
		getArticles(state) {
			if (state.gbbuArticles == null) {
				// pKey: process.env.VUE_APP_GRAPH_APIKEY,
				// this.sessionData = sessionStorage.getItem('gbbuArticles');
				fetch('https://ws-gbbu02.graphibox.eu/WebService.asmx/GetArticles', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json;  charset=utf-8' },
					body: JSON.stringify({
						pKey: 'bji3PXMCkqnoOK7sZfcEqn6s3m6kwEkJ',
						pId: 0,
						pIdCat: 0,
						pNbItems: 0,
					}),
				})
					.then(function(res) {
						return res.json();
					})
					.then((res) => {
						try {
							state.gbbuArticles = JSON.parse(res.d);
						} catch (error) {
							return '';
						}
					});
			}
		},
		increment(state) {
			state.count++;
		},
		updateName(state, newName) {
			state.globalData.name = newName;
		},
	},
});

export default store;
